import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { Carousel, ListGroup, ProgressBar, Spinner, Card, Modal, Button, Form, Image, Container, Row, Col, Alert } from 'react-bootstrap';
import { FaStar, FaStarHalfAlt, FaRegStar, FaInbox, FaPaperPlane, FaArrowLeft, FaDollarSign, FaFeather, FaFeatherAlt } from "react-icons/fa";
import { signInWithGoogle, auth, provider, signInWithPopup, onAuthStateChanged } from "./firebase";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import { deleteDoc, getFirestore, doc, limit, setDoc, getDoc, collection, query, where, getDocs, addDoc, serverTimestamp, onSnapshot, orderBy, updateDoc, increment } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject, ref as storageRef } from "firebase/storage";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { color, motion } from "framer-motion";
import LandingPage from "./LandingPage";
import { FaFeatherPointed } from "react-icons/fa6";
// import "./ChatCarousel.css"; // Import custom styles
import { toast } from "react-toastify"; // or your preferred toast system
// import messageSound from './mail.wav'; // Put this in /public or import properly
import mixpanel from 'mixpanel-browser';


const db = getFirestore();
let bColor
let lastNotifiedMessages = {};

const App = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [consultants, setConsultants] = useState([]);
  const [selectedConsultant, setSelectedConsultant] = useState(null);
  // find priest AOF
  const [selectedFocus, setSelectedFocus] = useState("");
  // activechat
  const [activeChats, setActiveChats] = useState([]);
  const [activeChat, setActiveChat] = useState(null);
  const [justChat, setJustChat] = useState(false);
  const [error, setError] = useState("");


  // credits
  const [customAmount, setCustomAmount] = useState("");
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [credits, setCredits] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [showRechargeModal, setShowRechargeModal] = useState(false);
  const [showPreRechargeModal, setShowPreRechargeModal] = useState(false);
  const countdownRef = useRef(null);
  const [paymentMethod, setPaymentMethod] = useState("stripe");

  const [isGift, setIsGift] = useState(false);
  const [recipientEmail, setRecipientEmail] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [showClaimModal, setShowClaimModal] = useState(false);
  const [claimMessage, setClaimMessage] = useState(""); // For feedback


  // **New states for chat request modal**
  const [tempConsultant, setTempConsultant] = useState(null);
  const [chatRequestModalVisible, setChatRequestModalVisible] = useState(false);
  const [isRequestingChat, setIsRequestingChat] = useState(false);
  const [guidelinesModal, setGuidelinesModal] = useState(false);
  const [customerCare, setCustomerCare] = useState(false);


  const [showMysub, setShowMySub] = useState(false);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [userPhoto, setUserPhoto] = useState('');
  const [userName, setUserName] = useState('');
  const [show, setShow] = useState(false);

  // fill questinaire
  const [isButtonPressed, setIsButtonPressed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModalQuestionaire, setShowModalQuestionaire] = useState(false);
  const [progress, setProgress] = useState(0);

  const [loadingauth, setLoadingauth] = useState(true); // Track authentication status

  // delete chat
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [chatToDelete, setChatToDelete] = useState(null);

  // ratings modal
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewConsultant, setReviewConsultant] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const debounceTimeout = useRef(null);

  const handleOpenReviewModal = (consultant) => {
    mixpanel.track('open review modal', {
      user: user.uid || 'no userid',
      // amount: amount
    })
    setReviewConsultant(consultant);
    setShowReviewModal(true);
  };

  // Claim handler
  const claimGift = async () => {
    if (!user?.email || !user?.uid) {
      setClaimMessage("Please log in to claim a gift card.");
      return;
    }

    try {
      const q = query(
        collection(db, "giftCards"),
        where("recipientEmail", "==", user.email)
      );

      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setClaimMessage("Sorry, you haven't been sent any gift cards.");
        return;
      }

      // Find the first unclaimed gift card
      const unclaimedDoc = querySnapshot.docs.find(
        (doc) => doc.data().status === "unclaimed"
      );

      if (!unclaimedDoc) {
        setClaimMessage("Gift card already claimed.");
        return;
      }

      const giftData = unclaimedDoc.data();
      const amount = giftData.amount;

      // Mark gift card as claimed
      await updateDoc(doc(db, "giftCards", unclaimedDoc.id), {
        status: "claimed",
        claimedAt: new Date(),
      });

      // Credit user
      const userRef = doc(db, "priest_users", user.uid);
      await updateDoc(userRef, {
        credits: increment(amount),
      });

      setClaimMessage(`$${amount} Gift card claimed successfully 🎉`);
    } catch (err) {
      console.error("Gift claim error:", err);
      setClaimMessage("An error occurred. Please try again.");
    }
  };


  // fill questionaires
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    motherName: "",
    fatherName: "",
    birthPlace: "",
    origin: "",
    dieties: "",
    rivers: "",
    facePhoto: null,
    rightPalmPhoto: null,
    leftPalmPhoto: null,
  });

  const focusAreas = [
    "Love, Marriage & Relationship",
    "Business & Start-up Consultancy",
    "Career & Financial Readings",
    "General Life Readings",
    "Future & Past Insights",
    "Health & Wellness",
    "My Spirituality",
    "Children & Parenting",
  ]

  const handleCloseMySub = () => setShowMySub(false);
  const handleShowMySub = () => {
    // mixpanel.track('mysubsfromup', {
    //   // message: "card clicked while signed in"
    // })
    setShowMySub(true);
  }


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  //AOF
  const handleChangeAOF = (event) => {
    setSelectedFocus(event.target.value);
  };


  const handleDeleteClick = (event, chatId) => {
    mixpanel.track('delete chat', {
      user: user.uid || 'no userid',
      // amount: amount
    })
    event.stopPropagation(); // Prevent triggering the card click
    // console.log(chatId)
    setChatToDelete(chatId);
    setShowDeleteModal(true);
  };

  // import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";

  // const deleteChatWithMessages = async (chatRoomId) => {
  //   const messagesRef = collection(db, "chatRooms", chatRoomId, "messages");
  //   const messagesSnapshot = await getDocs(messagesRef);

  //   // Delete all messages
  //   const deletions = messagesSnapshot.docs.map((msgDoc) => deleteDoc(msgDoc.ref));
  //   await Promise.all(deletions);

  //   // Now delete the chatRoom document itself
  //   await deleteDoc(doc(db, "chatRooms", chatRoomId));
  // };


  const deleteChatWithMessages = async (chatRoomId) => {
    const messagesRef = collection(db, "chatRooms", chatRoomId, "messages");
    const messagesSnapshot = await getDocs(messagesRef);

    const deletions = messagesSnapshot.docs.map(async (msgDoc) => {
      const msgData = msgDoc.data();

      // Delete audio file if message is audio
      if (msgData.type === "audio" && msgData.audio) {
        try {
          const audioPath = getStoragePathFromURL(msgData.audio);
          await deleteObject(storageRef(storage, audioPath));
        } catch (err) {
          console.error("Error deleting audio:", err);
        }
      }

      // Delete video file if message is video
      if (msgData.type === "video" && msgData.video) {
        try {
          const videoPath = getStoragePathFromURL(msgData.video);
          await deleteObject(storageRef(storage, videoPath));
        } catch (err) {
          console.error("Error deleting video:", err);
        }
      }

      // Delete the message document
      await deleteDoc(msgDoc.ref);
    });

    await Promise.all(deletions);

    // Delete the chatRoom document itself
    await deleteDoc(doc(db, "chatRooms", chatRoomId));
  };


  function getStoragePathFromURL(url) {
    const decodeUrl = decodeURIComponent(url);
    const matches = decodeUrl.match(/\/o\/(.*?)\?/);
    if (matches && matches[1]) {
      return matches[1];
    }
    throw new Error("Invalid Firebase Storage URL");
  }

  const confirmDeleteChat = async () => {
    mixpanel.track('confirm delete chat', {
      user: user.uid || 'no userid',
      // amount: amount
    })
    if (!chatToDelete) return;
    try {
      await deleteChatWithMessages(chatToDelete);;
      // console.log("Chat deleted successfully");
    } catch (error) {
      mixpanel.track('confirmDeleteChatError', {
        error: error,
        user: user.uid
      })
      console.error("Error deleting chat:", error);
    }
    setShowDeleteModal(false);
    setChatToDelete(null);
  };





  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      setUser(authUser);
      setLoadingauth(false); // Mark loading as complete
    });

    return () => unsubscribe();
  }, []);

  // useEffect(() => {
  //       setCustomerCare(false)
  // })


  // Fetch consultants from Firestore (only those with role "consultant")
  useEffect(() => {
    if (!user) return; // Wait for authentication

    // Create a Firestore query to listen in real time
    const consultantsQuery = query(
      collection(db, "priest_users"), // use the "priest_users" collection
      where("role", "==", "consultant")
    );
    // Listen for changes on this query
    const unsubscribe = onSnapshot(consultantsQuery, (querySnapshot) => {
      const consultantsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        name: doc.data().name,
        email: doc.data().email,
        username: doc.data().username,
        mode: doc.data().mode || 'offline',
        ratePerMinute: doc.data().ratePerMinute || 0,
        consultationCharge: doc.data().consultationCharge || 0,
        photoURL: doc.data().photoURL,
        tags: doc.data().tags,
        intro: doc.data().intro,
        rating: (() => {
          const ratingsArray = doc.data().rating || [];
          const total = ratingsArray.reduce((acc, val) => acc + val, 0);
          return ratingsArray.length ? total / ratingsArray.length : 0;
        })(),
        ratingArray: doc.data().rating || [],
        review: doc.data().review,
        reviewCount: doc.data().reviewCount
      }));

      // 🔽 Sort:
      const sortedData = consultantsData.sort((a, b) => {
        const targetId = "oVpyjIKguId9GcyB7uUukr6nxWf2";

        // Place the specific UID first
        if (a.id === targetId) return -1;
        if (b.id === targetId) return 1;

        // Then sort others so that "busy" ones are last
        if (a.mode === "busy" && b.mode !== "busy") return 1;
        if (a.mode !== "busy" && b.mode === "busy") return -1;
        return 0; // leave as is if both are busy or not
      });

      setConsultants(sortedData);

      // setConsultants(consultantsData);
    });
    return () => unsubscribe();
  }, [user]);




  // useEffect(() => {
  //   if (selectedConsultant && credits > 0) {
  //     startCreditTimer();
  //   } else if (credits <= 0) {
  //     clearInterval(countdownRef.current);
  //     setShowRechargeModal(true);
  //   }
  //   return () => clearInterval(countdownRef.current);
  // }, [selectedConsultant, credits]);

  // Listen for authentication state changes
  // useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
  //     // setUserName(currentUser.displayName)
  //     // setUserPhoto(currentUser.photoURL)
  //     setUser(currentUser); // Save user in state
  //   });

  //   return () => unsubscribe(); // Cleanup listener on unmount
  // }, []);


  useEffect(() => {
    if (isButtonPressed) {
      bColor = '#FFF2EE'
    } else {
      bColor = 'white'
    }

  }, [isButtonPressed]);


  // Load saved data from Firebase
  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;

      const docRef = doc(db, "priest_users", user.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setFormData(docSnap.data());
      }
    };

    fetchData();
  }, [user, db]);

  // Calculate progress dynamically
  useEffect(() => {
    const totalFields = Object.keys(formData).length;
    const filledFields = Object.values(formData).filter((value) => value && value !== "").length;
    setProgress(Math.round((filledFields / totalFields) * 100));
  }, [formData]);


  useEffect(() => {
    // console.log('user: ', user)
    // setUser(user)
    if (user?.uid) {
      const userRef = doc(db, "priest_users", user.uid);
      const unsubscribe = onSnapshot(userRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
          setCredits(docSnapshot.data().credits || 0);
        }
      });
      return () => unsubscribe();
    }
  }, [user]);


  useEffect(() => {
    if (user && user.uid) {
      const q = query(
        collection(db, "chatRooms"),
        where("user.id", "==", user.uid)
      );

      const unsubscribe = onSnapshot(q, async (querySnapshot) => {
        const chatPromises = querySnapshot.docs.map(async (chatDoc) => {
          const chatData = { id: chatDoc.id, ...chatDoc.data() };

          // Get the last message from the messages subcollection
          const messagesQuery = query(
            collection(db, "chatRooms", chatDoc.id, "messages"),
            orderBy("createdAt", "desc"),
            limit(1) // Only get the latest message
          );

          const messageSnapshot = await getDocs(messagesQuery);
          if (!messageSnapshot.empty) {
            const lastMessageDoc = messageSnapshot.docs[0];
            const lastMessage = lastMessageDoc.data();
            // console.log('lastMessage: ', lastMessage)
            chatData.lastMessage = lastMessage;
            // console.log('user: ', user)

            const isFromOtherUser = lastMessage.sender !== user.displayName;
            const messageId = lastMessageDoc.id;

            // Notify only if new, from other user, and not previously notified
            if (isFromOtherUser && lastNotifiedMessages[chatDoc.id] !== messageId) {
              lastNotifiedMessages[chatDoc.id] = messageId;

              if (document.hidden) {
                // User is on another tab — browser notification
                showBrowserNotification(lastMessage.text);
              } else {
                // In-app toast
                toast.info(`New message: ${lastMessage.text}`);
              }

              // playNotificationSound();
            }
          }




          // not very effecient since it calls all the time.
          // Fetch consultant username from priest_users using consultantId
          if (chatData.consultantId) {
            // console.log('chatData.consultantId: ', chatData.consultantId)
            try {
              const consultantRef = doc(db, "priest_users", chatData.consultantId);
              const consultantSnap = await getDoc(consultantRef);
              if (consultantSnap.exists()) {
                const consultantData = consultantSnap.data();
                chatData.consultantUserName = consultantData.username || consultantData.name;
              } else {
                chatData.consultantUserName = "Unknown Priest";
              }
            } catch (error) {
              console.error("Error fetching consultant username:", error);
              chatData.consultantUserName = "Unknown Priest";
              mixpanel.track('fetchConsultantNameError', {
                error: error,
                user: user.uid
              })
            }
          }


          return chatData;
        });

        const chatsWithMessages = await Promise.all(chatPromises);
        chatsWithMessages.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
        // console.log("activeChats: ", activeChats)
        setActiveChats(chatsWithMessages);
        // console.log('chatsWithMessages:', chatsWithMessages)
      });

      return () => unsubscribe();
    }
  }, [user]);


  useEffect(() => {
    if (justChat) {
      confirmChat();
    }
  }, [justChat]);



  // const startCreditTimer = () => {
  //   clearInterval(countdownRef.current);
  //   if (selectedConsultant) {
  //     setTimeRemaining(Math.floor(credits / selectedConsultant.ratePerMinute) * 60);
  //     countdownRef.current = setInterval(() => {
  //       setCredits((prev) => {
  //         if (prev <= 0) {
  //           clearInterval(countdownRef.current);
  //           setShowRechargeModal(true);
  //           return 0;
  //         }
  //         return prev - selectedConsultant.ratePerMinute / 60;
  //       });
  //       setTimeRemaining((prev) => Math.max(prev - 1, 0));
  //     }, 1000);
  //   }
  // };

  const goHome = () => {
    setSelectedConsultant(null)
    setShowPreRechargeModal(false);
  }

  const just_chat = () => {
    setJustChat(true)
    // confirmChat()
  }


  const storage = getStorage();


  // Instead of immediately selecting the consultant, first show the chat request modal.
  const handleConsultantSelect = (consultant) => {
    mixpanel.track('selected consultant', {
      user: user.uid || 'no userid',
      consultant: consultant.name || consultant.username
    })

    setTempConsultant(consultant);
    // console.log('consultant: ', consultant)
    // setChatRequestModalVisible(true);
    // ##########how far?
    if (consultant.email == 'okojieose111@gmail.com') {
      setCustomerCare(true)
    }

    if (consultant.mode !== 'busy') {
      setGuidelinesModal(true)
    } else {
      setTempConsultant(null);
      setCustomerCare(false)
      return
    }

    // confirmChat()
    // console.log('consultant', consultant)
  };

  // update user modes
  useEffect(() => {
    if (!user?.uid) return;

    const userRef = doc(db, "priest_users", user.uid);
    let lastActivity = Date.now();
    let writeInProgress = false;
    let queuedMode = null;

    const updateMode = async (mode) => {
      if (writeInProgress) {
        queuedMode = mode; // Queue the last requested mode
        return;
      }

      writeInProgress = true;
      try {
        await updateDoc(userRef, { mode });
      } catch (err) {
        console.error("Error updating mode:", err);
      } finally {
        writeInProgress = false;
        if (queuedMode && queuedMode !== mode) {
          const nextMode = queuedMode;
          queuedMode = null;
          updateMode(nextMode);
        }
      }
    };

    // Debounced version of setOnline
    const setOnline = () => {
      clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        updateMode("online");
      }, 500); // adjust delay to your preference
    };

    const setOffline = () => updateMode("offline");

    // Initial online on mount
    setOnline();

    const activityHandler = () => {
      lastActivity = Date.now();
      setOnline();
    };

    // Inactivity timeout
    const inactivityInterval = setInterval(() => {
      if (Date.now() - lastActivity > 5 * 60 * 1000) {
        setOffline();
      }
    }, 60 * 1000);

    // Event listeners
    const events = ["mousemove", "keydown", "touchstart", "touchmove"];
    events.forEach((event) => window.addEventListener(event, activityHandler));

    // Tab visibility
    const handleVisibility = () => {
      document.hidden ? setOffline() : setOnline();
    };
    document.addEventListener("visibilitychange", handleVisibility);

    // Tab close
    window.addEventListener("beforeunload", setOffline);

    return () => {
      clearTimeout(debounceTimeout.current);
      clearInterval(inactivityInterval);
      events.forEach((event) => window.removeEventListener(event, activityHandler));
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("beforeunload", setOffline);
    };
  }, [user]);




  const confirmChat = async () => {
    // setTempConsultant(consultant);
    // console.log('consultant', tempConsultant)
    // console.log('justChat', justChat)


    if (credits < 0.05 && justChat === false && tempConsultant?.ratePerMinute !== 0) {
      setShowPreRechargeModal(true)
      setChatRequestModalVisible(false)
      return
    }

    if (!tempConsultant) return;

    // setIsRequestingChat(true);
    // console.log('tempConsultant:', tempConsultant);

    try {
      // Generate a unique chatRoom ID
      // const chatRoomRef = doc(collection(db, "chatRooms"), `${user.uid}_${tempConsultant.id}`);
      const chatRoomId = `${user.uid}_${tempConsultant.id}`;
      const chatRoomRef = doc(db, "chatRooms", chatRoomId);

      // Check if the chat room already exists
      const chatRoomSnap = await getDoc(chatRoomRef);

      if (!chatRoomSnap.exists()) {
        // If it doesn't exist, create a new chat room
        await setDoc(chatRoomRef, {
          consultantName: tempConsultant.name,
          consultantPhoto: tempConsultant.photoURL,
          consultantId: tempConsultant.id,
          consultantEmail: tempConsultant.email,
          consultationCharge: tempConsultant.consultationCharge,
          user: { id: user.uid, name: user.displayName, photoURL: user.photoURL },
          createdAt: serverTimestamp(),
          status: "accepted"
        });

        // console.log("Chat room created:", chatRoomId);
      } else {
        // console.log("Chat room already exists:", chatRoomId);

      }

      // Set the active chat and navigate
      // const chatRoomId = chatRoomRef.id;
      setActiveChat({ chatRoomId, consultantName: tempConsultant.name, consultantPhoto: tempConsultant.photoURL, consultantEmail: tempConsultant.email, consultationCharge: tempConsultant.consultationCharge });
      setSelectedConsultant(tempConsultant);
      setChatRequestModalVisible(false);
      // setIsRequestingChat(false);
      // setTempConsultant(null);
      // console.log('tempConsultant:', tempConsultant)

      // Navigate to ActiveUserChat with required data
      navigate("/activeuserchat", {
        state: {
          selectedConsultant: tempConsultant,
          user: { id: user.uid, email: user.email, displayName: user.displayName, photoURL: user.photoURL },
          activeChat: { chatRoomId, consultantName: tempConsultant.name, consultantPhoto: tempConsultant.photoURL, consultantPrice: tempConsultant.ratePerMinute, consultantEmail: tempConsultant.email, consultationCharge: tempConsultant.consultationCharge },
        }
      });

    } catch (error) {
      console.error("Error creating chat room:", error);
      mixpanel.track('confirmChatError', {
        error: error,
        user: user.uid
      })
    }
  };

  const rechargeCredits = () => {
    mixpanel.track('recharge modal true', {
      // user: user.uid || 'no userid',
      // consultant: consultant.name || consultant.username
    })
    // setCredits(20); // Add 20 more credits
    setShowRechargeModal(true);
    // startCreditTimer();
  }

  const openRechargeModal = () => {
    mixpanel.track('open regcharge modal', {
      user: user.email,
    })
    setShowRechargeModal(true);
    setShowPaymentForm(false);
  };

  // const handleAmountSelect = (amount) => {
  //   setSelectedAmount(amount);
  //   setShowPaymentForm(true);
  // };

  // const handlePayment = (event) => {
  //   event.preventDefault();
  //   if (selectedAmount) {
  //     setCredits((prev) => prev + selectedAmount);
  //     setShowRechargeModal(false);
  //     alert(`You have successfully purchased {selectedAmount}🪶!`);
  //   }
  // };

  const handleCheckout = async (amount, isGift, recipientEmail, recipientName) => {
    try {
      if (amount <= 14.99) {
        alert("Amount must be greater than 14.99");
        return;
      }

      if (isGift) {
        if (recipientName === "" || recipientEmail === "") {
          setError('Please fill in details of receiver!');
          return;
        }

      }

      setError("")


      mixpanel.track('handle checkout', {
        user: user.uid || 'no userid',
        amount: amount,
        isGift,
        // recipientEmail,
        // recipientName,
        // userName
      })

      // TODO: looks at this charges again for correctness
      // Add your 10% platform fee
      const platformFeeRate = 0.10;
      // const stripeFeeRate = 0.015;  // 1.5%
      // const stripeFixedFee = 0.3;  // $0.3

      // Add your 10% platform fee
      let totalAmount = amount * (1 + platformFeeRate);

      // Calculate Stripe reverse fee
      // const finalAmountToCharge = (targetAmount + stripeFixedFee) / (1 - stripeFeeRate);

      // console.log("User ID:", user?.uid);
      // console.log("User wants to send to priest:", amount);
      // console.log("After 10% platform fee, total is:", totalAmount);
      // console.log("Including Stripe fee, user should be charged:", finalAmountToCharge.toFixed(2));

      const endpoint = paymentMethod === "paystack"
        ? "https://www.priests.africa/api/paystackpayments"
        : "https://www.priests.africa/api/payments";

      if (paymentMethod == "paystack") {
        // convert to naira for paystack
        totalAmount = totalAmount * 2000
      }

      // const endpoint = paymentMethod === "paystack"
      // ? "http://localhost:3000/api/paystackpayments"
      // : "https://www.priests.africa/api/payments";

      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount: totalAmount, myamount: amount, userId: user?.uid, isGift: isGift, recipientEmail: isGift ? recipientEmail : null, recipientName: isGift ? recipientName : null, senderName: user?.displayName }),
      });
      const data = await response.json();
      // console.log("API Response:", data);
      // console.log("Response:", response);


      if (!data.url) {
        console.log("Response from backend:", data);
        throw new Error("No URL returned from backend");
      }

      window.location.href = data.url;
    } catch (error) {
      mixpanel.track('handleCheckOutError', {
        error: error?.message,
        user: user?.uid
      })
      console.error("Checkout error:", error);
    }
  };



  const handleGoogleSignup = async () => {
    mixpanel.track('signing up in app.js', {
      // user: user.uid || 'no userid',
      // consultant: consultant.name || consultant.username
    })
    const googleUser = await signInWithGoogle();
    if (googleUser) {
      setUser(googleUser);
      // console.log("googleUser: ", googleUser)

      const db = getFirestore();

      const userRef = doc(db, "priest_users", googleUser.uid);
      let userSnap = await getDoc(userRef);
      setIsSignedIn(true);
      setUserPhoto(googleUser.photoURL)
      setUserName(googleUser.displayName);

      if (!userSnap.exists()) {
        // If user does not exist in Firestore, create a new record
        await setDoc(userRef, {
          uid: googleUser.uid,
          name: googleUser.displayName,
          email: googleUser.email,
          role: "user",
          credit: 0, // Default earnings
          // ratePerMinute: 2, // Default rate,
          photoURL: googleUser.photoURL,
          email: googleUser.email
        });

        // Re-fetch user data to get the latest role
        // userSnap = await getDoc(userRef);

      }

      // Redirect if user is a consultant
      if (userSnap.exists() && userSnap.data().role === "consultant") {
        // navigate to "/consultant-dashboard"
        navigate("/dashboard"); // Navigate using the passed function
        // window.location.href = "/dashboard";
        // console.log("role: ", userSnap.data().role)
      }


    }

  };

  const handleAdvice = () => {
    mixpanel.track('navigate to consultant', {
      // user: user.uid || 'no userid',
      // consultant: consultant.name || consultant.username
    })
    navigate("/dashboard");
  }



  // const handleSignIn = async () => {
  //   try {
  //     const result = await signInWithPopup(auth, provider);
  //     setUser(result.user); // Save user in state
  //   } catch (error) {
  //     console.error("Google Sign-in Error:", error);
  //   }
  // };

  const handleSignOut = async () => {
    mixpanel.track('signing out', {
      // user: user.uid || 'no userid',
      // consultant: consultant.name || consultant.username
    })
    await auth.signOut();
    setIsSignedIn(false);
    setUser(null);
  };

  // Handle file selection
  const handleFileChange = (e, field) => {
    setFormData({ ...formData, [field]: e.target.files[0] });
  };

  // Upload images to Firebase Storage
  const uploadFile = async (file, path) => {
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    return getDownloadURL(storageRef);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Upload images
      const facePhotoURL = formData.facePhoto ? await uploadFile(formData.facePhoto, `users/${user.uid}/face.jpg`) : "";
      const rightPalmURL = formData.rightPalmPhoto ? await uploadFile(formData.rightPalmPhoto, `users/${user.uid}/right_palm.jpg`) : "";
      const leftPalmURL = formData.leftPalmPhoto ? await uploadFile(formData.leftPalmPhoto, `users/${user.uid}/left_palm.jpg`) : "";

      // Save data to Firestore
      await setDoc(doc(db, "priest_users", user.uid), {
        name: formData.name,
        dob: formData.dob,
        motherName: formData.motherName,
        fatherName: formData.fatherName,
        birthPlace: formData.birthPlace,
        origin: formData.origin,
        dieties: formData.dieties,
        rivers: formData.rivers,
        facePhotoURL,
        rightPalmURL,
        leftPalmURL,
      });

      setLoading(false);
      handleClose();
    } catch (error) {
      console.error("Error saving data:", error);
      setLoading(false);
      mixpanel.track('handleFormError', {
        error: error,
        user: user.uid
      })
    }
  };

  const handleCloseQuestionaire = () => {
    setShowModalQuestionaire(false)
  }




  // console.log("isSignedIn: ", isSignedIn)

  const renderStars = (rating) => {
    const stars = [];
    const rounded = Math.round(rating * 2) / 2; // Round to nearest 0.5

    for (let i = 1; i <= 5; i++) {
      if (i <= rounded) {
        stars.push(<FaStar key={i} color="#ffc107" />);
      } else if (i - 0.5 === rounded) {
        stars.push(<FaStarHalfAlt key={i} color="#ffc107" />);
      } else {
        stars.push(<FaRegStar key={i} color="#e4e5e9" />);
      }
    }

    return stars;
  };

  if (loadingauth) {
    return <div className="loading-container">
      {/* <img src="./logo.png" alt="Brand Logo" className="loading-logo" /> */}
      <Spinner animation="border" variant="success" className="loading-spinner" />
      <p className="loading-text">A new victory is loading for you...</p>
    </div>; // Or a nice spinner
  }



  if (user == null) {
    return <LandingPage />;
  }


  function showBrowserNotification(messageText) {
    if ("Notification" in window) {
      if (Notification.permission === "granted") {
        new Notification("New Message", {
          body: messageText,
          icon: "/icon.png", // Optional
        });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            showBrowserNotification(messageText);
          }
        });
      }
    }
  }

  // function playNotificationSound() {
  //   const audio = new Audio(messageSound); // or '/message.mp3' if public
  //   audio.play().catch((e) => console.warn("Audio play failed:", e));
  // }

  const filteredConsultants = consultants.filter((c) => {
    const matchesSearch =
      !searchTerm ||
      c.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.tags?.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));

    const matchesCategory =
      !selectedFocus || (c.tags || []).some(tag => tag.toLowerCase() === selectedFocus.toLowerCase());

    return matchesSearch && matchesCategory;
  });


  // const filteredConsultants = selectedFocus
  // ? consultants.filter((c) => (c.tags || []).includes(selectedFocus))
  // : consultants; // Default: Show all consultants


  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f3f3f3" }} className="container-fluid p-0">
      <div className="container-fluid p-1" >
        <div className="container-fluid p-1">
          <nav bg="dark" className="navbar navbar-expand  shadow-sm" style={{ "padding": "0px", margin: 0, backgroundColor: "white", borderRadius: 10 }} >
            <a href="https://www.priests.africa" className="navbar-brand" style={{ "color": '#CCCCCC', margin: 5, marginLeft: 10 }} > <img src="./logo.png" width="110" alt="logo" />  </a>

            <div class="collapse navbar-collapse" id="toggleMobileMenu">
              <ul class="navbar-nav">
              </ul>
            </div>
            <div class="collapse navbar-collapse" id="toggleMobileMenu">
              <ul class="navbar-nav">
              </ul>
            </div>
            <div style={{ align: 'right' }} class="collapse navbar-collapse" id="toggleMobileMenu">
              <ul class="navbar-nav">
                <span class="navbar-text">
                  {/* <a onClick={handleShow} class="navbar-brand" style={{"color": '#CCCCCC', margin:5}} > <img src="./menu.png" width="30" />  </a> */}
                </span>
              </ul>
            </div>

            <Button variant="light" style={{}} onClick={openRechargeModal}>
              <h5 style={{ color: "grey", }}>{credits === null ? "Loading..." : credits.toFixed(2)}

                <img
                  src="/cowrieblack.png" // Update with the correct path
                  alt="Feather Icon"
                  style={{ width: '20px', height: '20px' }}
                />

              </h5>
            </Button>
            <div onClick={() => setShowClaimModal(true)} style={{ fontSize: 25, margin: 5, cursor: "pointer" }}>
              🎁
              {/* <img src="/gift5.png"
                style={{ width: '30px', height: '30px'}}
              /> */}
            </div>

            <span class="navbar-text">
              <div className="collapse navbar-collapse">
                <ul className="navbar-nav mr-auto">
                  {/* display profile photo here */}
                  <li className="nav-item">
                    <a onClick={handleShowMySub}>
                      {!user ? (
                        <img
                          src={"./account.png"}
                          alt={"profile"}
                          style={{ width: 40, height: 40, borderRadius: '50%', margin: 5 }}
                        />
                      ) : (
                        <img
                          src={user.photoURL}
                          alt={user.displayName}
                          style={{ width: 40, height: 40, borderRadius: '50%', margin: 5 }}
                          onClick={show ? handleClose : handleShow}
                        />
                      )}

                    </a>
                  </li>
                </ul>
                {/* <ul className="navbar-nav mr-auto">
                  <li className="nav-item">
                    <a onClick={show ? handleClose : handleShow} className="nav-link" style={{ color: '#CCCCCC', margin: 5 }}>
                      <img src={show ? "./close.png" : "./menu.png"} width="35" alt="menu" />
                    </a>
                  </li>
                </ul> */}
              </div>

            </span>

          </nav>
        </div>


        {/* <div
        className="text-center py-4 px-3"
        style={{
          backgroundColor: "#ffffff",
          borderBottom: "1px solid #e0e0e0",
          fontFamily: "Inter, sans-serif",
        }}
      >
        <div
          style={{
            maxWidth: "600px",
            margin: "0 auto",
            padding: "20px",
            borderRadius: "10px",
            backgroundColor: "#f9f9f9",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.03)",
          }}
        >
          <h5 style={{ color: "#333", marginBottom: "10px" }}>
            We're not live yet 🚧
          </h5>
          <p style={{ color: "#777", fontSize: "0.95rem", marginBottom: 0 }}>
            Our official launch is coming soon: <strong>June 23, 2025</strong>. Stay tuned.
          </p>
        </div>
      </div> */}



        <Container>
          <p className="text-muted mb-2 small mt-2" style={{ fontFamily: "Inter, sans-serif", marginBottom: 15, color: "grey", }}>
            Resume Chat
          </p>
          <Card.Body>
            {activeChats.length === 0 ? (
              <Card
                style={{
                  minWidth: "250px",
                  maxWidth: "300px",
                  flex: "0 0 auto",
                  borderRadius: "10px",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "white",
                  color: "black",
                }}>
                <p style={{ margin: 20, color: 'grey' }}>You don't have any chats yet.</p>
              </Card>

            ) : (
              <div
                style={{
                  display: 'flex',
                  overflowX: 'auto',
                  paddingBottom: '10px',
                  gap: '10px',
                }}
              >

                {activeChats.map((chat) => {
                  const userLastSeen = chat.lastSeen?.[user.uid]?.seconds || 0;
                  const hasUnseenMessage =
                    chat.lastMessage && chat.lastMessage.createdAt.seconds > userLastSeen;

                  return (
                    <Card
                      className="shadow-sm border-0 h-100"
                      key={chat.id}
                      style={{
                        minWidth: "250px",
                        maxWidth: "300px",
                        flex: "0 0 auto",
                        borderRadius: "10px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "white",
                        color: "black",
                      }}
                      onClick={() => {
                        const consultant = consultants.find(c => c.id === chat.consultantId);

                        navigate("/activeuserchat", {

                          state: {
                            user: {
                              id: user.uid,
                              name: user.displayName,
                              email: user.email,
                              photoURL: user.photoURL,
                            },
                            selectedConsultant: {
                              id: chat.consultantId,
                              name: chat.consultantUserName || chat.consultantName,
                              // username: chat.consultantUserName,
                              photoURL: chat.consultantPhoto,
                              email: consultant.email,
                              consultationCharge: consultant.consultationCharge
                            },
                            activeChat: { ...chat, consultantEmail: consultant.email, chatRoomId: chat.id, consultantPrice: consultant ? consultant.ratePerMinute : 0, consultationCharge: consultant.consultationCharge },
                          },
                        });

                        // ✅ Update lastSeen when user clicks the chat
                        updateDoc(doc(db, "chatRooms", chat.id), {
                          [`lastSeen.${user.uid}`]: serverTimestamp(),
                        });
                      }}
                    >
                      <Card.Body>
                        <div className="d-flex align-items-center">
                          <div className="rounded-circle">
                            {/* Profile Image */}
                            <Image
                              src={chat.consultantPhoto || "https://via.placeholder.com/40"}
                              roundedCircle
                              style={{ width: "50px", height: "50px", objectFit: "cover" }}
                              className="me-3"
                            />
                          </div>


                          {/* Chat Info */}
                          <div className="d-flex flex-column flex-grow-1" style={{ minWidth: 0 }}>
                            <strong style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}>
                              {chat.consultantUserName || "Anonymous User"}
                            </strong>

                            {/* Last message with Unread Badge */}
                            <div className="d-flex align-items-center justify-content-between">
                              <p
                                className="text-muted mb-1 small"
                                style={{
                                  fontSize: "1rem",
                                  color: "#acb9ab",
                                  flexGrow: 1,
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {/* Only display first 10 characters */}
                                {chat.lastMessage?.text?.substring(0, 20) || chat.lastMessage?.type || "No message"}...
                              </p>

                              {/* Unseen message indicator (FaInbox icon) */}
                              {hasUnseenMessage && (
                                <div
                                  className="badge bg-success text-white ms-2"
                                  style={{ borderRadius: "1000px" }}
                                >
                                  <img
                                    src="/mail.png" // Make sure this is the correct path
                                    alt="New Message"
                                    width={20} // Adjust size as needed
                                    height={20}
                                    style={{}}
                                  />
                                </div>
                              )}
                            </div>

                            {/* Timestamp */}
                            <div className="d-flex justify-content-between align-items-center">
                              <p className="text-muted mb-0" style={{ fontSize: "0.8rem" }}>
                                {chat.lastMessage?.createdAt?.toDate().toLocaleString() || "No Date"}
                              </p>
                              {/* </div> */}
                              <button onClick={(event) => handleDeleteClick(event, chat.id)} style={{ background: "none", border: "none", cursor: "pointer" }}>
                                <img
                                  src="/delete.png" // Update with the correct path
                                  alt="delete"
                                  style={{ width: '30px', height: '30px' }}
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })
                }
              </div>
            )}
          </Card.Body>

        </Container>

        {/* Priest Search Section */}
        <Container className="mt-3">
          <p className="text-muted mb-1 small mt-2" style={{ fontFamily: "Inter, sans-serif", marginBottom: 15, color: "grey", }}>
            New Chat
          </p>

          {/* Search Input */}
          <div className="mb-2 mt-2">
            <Form.Control
              type="text"
              placeholder="Search by name, tradition, town or specialty..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="shadow-sm border-0"
              style={{
                borderRadius: "12px",
                padding: "12px 16px",
                fontSize: "15px",
              }}
            />
          </div>

          {/* Quick Category Chips */}
          <div className="mb-1 mt-1" style={{ paddingLeft: "8px", paddingRight: "8px", display: "flex", justifyContent: "center", gap: "4px", overflowX: "auto", whiteSpace: "nowrap" }}>
            {["Babalawo", "Dibia", "Sangoma", "Bokor", "Iyanifa", "Ifa",].map((category) => (
              <Button
                key={category}
                variant={selectedCategory === category ? "success" : "outline-success"}
                size="sm"
                className="mt-0 mb-1"
                style={{
                  borderRadius: "50px",
                  padding: "6px 14px",
                  fontSize: "12px",
                  fontWeight: 500,
                }}
                onClick={() => {
                  const newCategory = category === selectedCategory ? "" : category;
                  setSelectedCategory(newCategory);
                  setSearchTerm(newCategory); // This makes it appear in the search field
                }}>
                {category}
              </Button>
            ))}
          </div>

          {/* Filtered Results */}
          <div
            style={{
              maxHeight: '70vh',  // Adjust based on your layout
              overflowY: 'auto',
              paddingRight: '8px', // Prevent scrollbar from overlaying content
            }}
          >


            <Row>
              {filteredConsultants.length > 0 ? (
                filteredConsultants.map((c) => (
                  <Col md={6} lg={4} key={c.id} className="mb-4 d-flex">
                    <Card
                      className="shadow-sm border-0 flex-fill"
                      style={{ borderRadius: "14px", cursor: "pointer" }}
                      onClick={() => handleConsultantSelect(c)}
                    >
                      <Card.Body className="d-flex flex-column">
                        {/* Image + Status */}
                        <div className="d-flex align-items-center mb-3">
                          <div className="position-relative me-3">
                            <Image
                              src={c.photoURL || "/default-avatar.png"}
                              alt={c.username || c.name}
                              className="rounded-circle border"
                              style={{ width: "60px", height: "60px", objectFit: "cover" }}
                            />
                            {/* <span
                        className={`position-absolute bottom-0 end-0 p-1 rounded-circle border border-white ${
                          c.mode === "online" ? "bg-success pulse-circle" : "bg-secondary"
                        }`}
                        style={{ width: "16px", height: "16px" }}
                      /> */}
                            <motion.span
                              className={`position-absolute bottom-0 end-0 p-1 rounded-circle border border-white ${c.mode === "online"
                                  ? "bg-success"
                                  : c.mode === "busy"
                                    ? "bg-danger"
                                    : "bg-secondary"
                                }`}
                              style={{ width: "14px", height: "14px" }}
                              animate={c.mode === "online" ? { scale: [0.8, 1.3, 0.8] } : {}}
                              transition={{ duration: 1.5, repeat: Infinity }}
                            />

                          </div>
                          <div>
                            <h6 className="fw-bold mb-0">{c.username || c.name}</h6>
                            <small className="text-muted">{c.tags?.join(", ") || "No specialty"}</small>
                          </div>
                        </div>

                        {/* Intro */}
                        <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                          {c.intro?.substring(0, 80) || "No introduction set yet."}
                        </p>

                        {/* Price & Reviews */}
                        <div className="d-flex justify-content-between align-items-center mt-auto">
                          <div className="d-flex align-items-center text-warning" onClick={(e) => {
                            e.stopPropagation(); // Prevent card's onClick from firing
                            handleOpenReviewModal(c); // Open review modal for this consultant
                            }}>
                            {renderStars(c.rating || 0)}
                            <small className="ms-1 text-muted">
                              {c.reviewCount || 0} reviews
                            </small>
                          </div>
                          
                          {/* <div className="d-flex align-items-center" title="Number of red flags reported">
      <span style={{ fontSize: "1rem", marginRight: "4px", color: "red" }}>🚩</span>
      <small className="text-danger fw-bold">{c.redFlagCount || 0}
      </small>
    </div> */}
    
                          <small className="text-muted fw-bold">
                            {c.ratePerMinute || c.consultationCharge}{" "}
                            <img src="/cowrieblack.png" alt="Cowrie Icon" style={{ width: 16, height: 16 }} />
                            /{c.ratePerMinute ? "min" : "consult"}
                          </small>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              ) : (
                <p className="text-muted text-center mt-4">
                  Please check back. We're currently verifying Priests for this focus area.
                </p>
              )}
            </Row>
          </div>
        </Container>


        {/* <div className="text-center font-bold text-lg">Credits: {credits.toFixed(2)}</div> */}
        {/* former card list was placed here before we intro. types of priests */}
      </div>



      {/* Chat Request Modal */}
      <Modal
        show={chatRequestModalVisible}
        onHide={() => {
          setChatRequestModalVisible(false);
          setTempConsultant(null);
        }}
        centered
        className="rounded-3 shadow-lg"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold text-primary">Chat Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-3">
          <p className="fs-5 text-muted">
            You are about to chat with{" "}
            <span className="fw-bold text-dark">
              {tempConsultant?.username?.trim()
                ? tempConsultant.username
                : tempConsultant?.name}
            </span>. You'll be charged for the time <span className="fw-bold text-dark">
              {tempConsultant?.username?.trim()
                ? tempConsultant.username
                : tempConsultant?.name}
            </span> spends responding to your chat. Do you want to proceed?
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="outline-secondary"
            size="lg"
            onClick={() => {
              setChatRequestModalVisible(false);
              setTempConsultant(null);
            }}
          >
            Cancel
          </Button>
          <Button variant="primary" size="lg" onClick={confirmChat}>
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Safety rules */}
      <Modal
        show={guidelinesModal}
        onHide={() => {
          setGuidelinesModal(false);
          setCustomerCare(false)
        }}
        centered
        className="rounded-3 shadow-lg"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold text-primary">Chat Guidelines</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-0">
          {/* <p className="fs-6 text-muted">
          You are about to chat with {" "}
          <span className="fw-bold text-dark">
            {tempConsultant?.username?.trim()
              ? tempConsultant.username
              : tempConsultant?.name}
          </span>. 
        </p> */}

          {customerCare ? (
            <div className="fs-6 text-muted">
              <p>
                You are about to chat with the{" "}
                <strong>Care representative for Priests.Africa</strong>.
              </p>
              {/* <p className="fs-5 text-muted">Do you wish to proceed?</p> */}
            </div>
          ) : (

            <div className="fs-6 text-muted">
              <p>
                You are about to chat with{" "}
                {tempConsultant?.username?.trim()
                  ? tempConsultant.username
                  : tempConsultant?.name}
                .
                {tempConsultant?.ratePerMinute !== 0 && (<strong className="fw-bold text-primary">
                  {" "}
                  You'll be charged for the time he/she spends responding to your chat.
                </strong>
                )}
              </p>
              <ul>
                <li>
                  Our priests are here only to <strong>offer guidance and advice</strong>.
                  Any decisions you make are <strong>entirely your own responsibility</strong>.
                </li>
                <li>
                  <strong>Do not share personal contact information</strong> (phone numbers, emails, social media, etc.).
                </li>
                <li>
                  All consultations should <strong>remain within the app</strong> for your safety and to ensure the protection of our platform’s standards.
                </li>
                <li>
                  Any discussions or transactions outside this platform{" "}
                  <strong>are not endorsed or protected</strong> by this service.
                </li>
              </ul>
              {/* </div> */}


              <p className="fs-5 text-muted">
                Do you wish to proceed?
              </p>

            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="outline-secondary"
            size="lg"
            onClick={() => {
              setGuidelinesModal(false);
              // setTempConsultant(null);
              setCustomerCare(false)

            }}
          >
            Cancel
          </Button>
          <Button variant="primary" size="lg" onClick={() => {
            confirmChat();
            // setCustomerCare(false)
            // setCustomerCare(false)s

          }}>
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Recharge Modal */}
      <Modal show={showPreRechargeModal} centered className="rounded-3 shadow-lg">
        <Modal.Body className="px-4 py-3 text-center">
          <p className="fs-5 text-muted">Your credits have run out. You can only send a message but won't get one back.
            Do you want to recharge?</p>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="success" size="lg" onClick={rechargeCredits}>
            Recharge
          </Button>
          <Button variant="primary" size="lg" onClick={() => just_chat()}>
            Continue
          </Button>
          <Button variant="danger" size="lg" onClick={() => goHome(null)}>
            End Chat
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Payment Modal */}
      <Modal show={showRechargeModal} onHide={() => {
        setShowRechargeModal(false);
        setIsGift(false); setRecipientEmail(""); setRecipientName(""); setError(""); setCustomAmount("")
      }} centered className="rounded-4" contentClassName="border-0 shadow-lg">
        <Modal.Header closeButton className="border-0 px-4 pt-4">
          <Modal.Title className="fw-semibold fs-5 text-success">Enter Credit Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 pb-4 pt-2">
          <div className="d-flex flex-column align-items-center gap-3 w-100">
            {/* <Form.Text className="text-muted w-100 text-start" style={{ fontSize: 13 }}>
            1 USD = 1 Cowrie 
        </Form.Text> */}
            {/* <p className="text-muted small mb-0">
          1 USD = 1 Cowrie
        </p> */}
            {/* <p className="text-muted small mb-2">
          Priests.Africa fee = 10%
          (all transaction fees included)
        </p> */}
            <div className="w-100" style={{ maxWidth: "320px" }}>
              <label className="form-label text-muted mb-1" style={{ fontSize: "12px" }}>
                1 USD = 1 Cowrie
              </label>
              <input
                type="number"
                className="form-control text-center"
                style={{
                  maxWidth: "320px",
                  borderRadius: "12px",
                  padding: "12px 16px",
                  fontSize: "15px",
                  border: "1px solid #dee2e6",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease"
                }}
                placeholder="Enter amount (minimum $15.0)"
                value={customAmount}
                onChange={(e) => setCustomAmount(e.target.value)}
                min="20.0"
              />
            </div>



            <div className="w-100" style={{ maxWidth: "320px" }}>
              <Form.Label className="text-muted mb-1" style={{ fontSize: "12px" }}>
                Choose Payment Method
              </Form.Label>
              <select
                className="form-select"
                style={{
                  borderRadius: "12px",
                  padding: "10px 14px",
                  fontSize: "15px",
                  border: "1px solid #dee2e6"
                }}
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
              >
                <option value="stripe">💳 Pay with Stripe</option>
                {/* <option value="paystack">💰 Pay with Paystack</option> */}
              </select>
            </div>

            {/* Gift Checkbox */}
            <div className="d-flex justify-content-center w-100" style={{ maxWidth: "320px" }}>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="giftCheckbox"
                  checked={isGift}
                  onChange={() => setIsGift(!isGift)}
                />
                <label className="form-check-label text-muted ms-0" htmlFor="giftCheckbox" style={{ fontSize: "14px" }}>
                  🎁 Send gift of divination to a friend?
                </label>
              </div>
            </div>


            {/* Recipient Email Input */}
            {isGift && (
              <input
                type="email"
                className="form-control"
                style={{
                  maxWidth: "320px",
                  border: "1px solid #dee2e6",
                  borderRadius: "12px",
                  padding: "10px 14px",
                  fontSize: "15px",
                  border: "1px solid #dee2e6",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                }}
                placeholder="Recipient's email address?"
                value={recipientEmail}
                onChange={(e) => setRecipientEmail(e.target.value)}
              />
            )}

            {isGift && (
              <input
                type="name"
                className="form-control"
                style={{
                  maxWidth: "320px",
                  borderRadius: "12px",
                  padding: "10px 14px",
                  fontSize: "15px",
                  border: "1px solid #dee2e6",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                }}
                placeholder="Recipient's name?"
                value={recipientName}
                onChange={(e) => {
                  const name = e.target.value;
                  const capitalized =
                    name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
                  setRecipientName(capitalized);
                }}
              />
            )}

            <p className="text-muted small mt-2 mb-2">
              Priests.Africa fee = 10%
              (all transaction fees included)
            </p>

            {error && <Alert variant="danger">{error}</Alert>}

            <Button
              variant="success"
              className="fw-semibold mt-2"
              style={{
                padding: "10px 24px",
                borderRadius: "14px",
                fontSize: "15px",
                boxShadow: "0 4px 10px rgba(0, 123, 255, 0.2)",
                transition: "background-color 0.3s ease"
              }}
              onClick={() => handleCheckout(Number(customAmount), isGift, recipientEmail, recipientName)}
              disabled={!customAmount || Number(customAmount) <= 1}
            >
              Pay ${customAmount || 0} with {paymentMethod === "stripe" ? "Stripe" : "Paystack"}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showClaimModal}
        onHide={() => {
          setShowClaimModal(false);
          setClaimMessage("");
        }}
        centered
        contentClassName="border-0 shadow-sm"
      >
        <Modal.Header closeButton className="border-0 px-4 pt-4">
          <Modal.Title className="fw-semibold fs-5 text-success">Claim Your Gift</Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4 pb-4 pt-2">
          <p className="text-muted text-center mb-4" style={{ fontSize: 15 }}>
            Received a Priests.Africa  gift card? <strong></strong><br />
          </p>

          {claimMessage && (
            <div
              className="fw-semibold text-dark"
              style={{
                fontSize: 15,
                textAlign: "center",
                marginBottom: "12px",
              }}
            >
              {claimMessage}
            </div>
          )}



          <Button
            onClick={claimGift}
            className="mt-4 w-100"
            style={{
              borderRadius: "14px",
              padding: "10px 24px",
              fontWeight: 600,
              fontSize: "15px",
              boxShadow: "0 4px 10px rgba(0, 123, 255, 0.15)",
            }}
            variant="success"
          >
            🎁 Claim Gift
          </Button>
        </Modal.Body>
      </Modal>

      <Modal show={showModalQuestionaire} onHide={handleCloseQuestionaire} centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold text-primary">Questionnaire</Modal.Title>
        </Modal.Header>

        {/* Animated Progress Bar */}
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
          <ProgressBar
            now={progress}
            label={`${progress}%`}
            className="rounded-3 mt-2 mx-3"
            animated
            variant={progress === 100 ? "success" : "primary"}
          />
        </motion.div>

        <Modal.Body>
          <Card className="p-3 shadow-sm border-0 rounded-4">
            <Form onSubmit={handleSubmit}>
              {/* Name & DOB */}
              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Full Name</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="rounded-3"
                  placeholder="Enter your full name"
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Date of Birth</Form.Label>
                <Form.Control
                  type="date"
                  required
                  value={formData.dob}
                  onChange={(e) => setFormData({ ...formData, dob: e.target.value })}
                  className="rounded-3"
                />
              </Form.Group>

              {/* Parent Details */}
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label className="fw-semibold">Mother's Name</Form.Label>
                    <Form.Control
                      type="text"
                      required
                      value={formData.motherName}
                      onChange={(e) => setFormData({ ...formData, motherName: e.target.value })}
                      className="rounded-3"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label className="fw-semibold">Father's Name</Form.Label>
                    <Form.Control
                      type="text"
                      required
                      value={formData.fatherName}
                      onChange={(e) => setFormData({ ...formData, fatherName: e.target.value })}
                      className="rounded-3"
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Birthplace & Origin */}
              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Birth Place</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={formData.birthPlace}
                  onChange={(e) => setFormData({ ...formData, birthPlace: e.target.value })}
                  className="rounded-3"
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">Place of Origin</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={formData.origin}
                  onChange={(e) => setFormData({ ...formData, origin: e.target.value })}
                  className="rounded-3"
                />
              </Form.Group>

              {/* Photo Uploads */}
              <Row>
                <Col md={6} className="mb-4">
                  <Form.Group>
                    <Form.Label className="fw-semibold">Photo of Face</Form.Label>
                    {formData.facePhoto && <img src={formData.facePhoto} className="img-fluid rounded-3 shadow-sm" alt="Face" />}
                    <Form.Control type="file" accept="image/*" onChange={(e) => handleFileChange(e, "facePhoto")} className="rounded-3" />
                  </Form.Group>
                </Col>
                <Col md={6} className="mb-4">
                  <Form.Group>
                    <Form.Label className="fw-semibold">Right Palm</Form.Label>
                    {formData.rightPalmPhoto && <img src={formData.rightPalmPhoto} className="img-fluid rounded-3 shadow-sm" alt="Right Palm" />}
                    <Form.Control type="file" accept="image/*" onChange={(e) => handleFileChange(e, "rightPalmPhoto")} className="rounded-3" />
                  </Form.Group>
                </Col>
                <Col md={6} className="mb-4">
                  <Form.Group>
                    <Form.Label className="fw-semibold">Left Palm</Form.Label>
                    {formData.leftPalmPhoto && <img src={formData.leftPalmPhoto} className="img-fluid rounded-3 shadow-sm" alt="Left Palm" />}
                    <Form.Control type="file" accept="image/*" onChange={(e) => handleFileChange(e, "leftPalmPhoto")} className="rounded-3" />
                  </Form.Group>
                </Col>
              </Row>

              {/* Submit Button */}
              <div className="d-flex justify-content-end">
                <Button variant="outline-secondary" className="me-2 px-4 py-2 rounded-3" onClick={handleCloseQuestionaire}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit" className="px-4 py-2 rounded-3" disabled={loading}>
                  {loading ? <Spinner size="sm" animation="border" /> : "Submit"}
                </Button>
              </div>
            </Form>
          </Card>
        </Modal.Body>
      </Modal>


      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold text-primary">Delete?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-5 text-muted">
            Sure you want to delete this chat?
          </p>
          <p className="fs-6 text-muted">
            Once it's deleted, it gone forever!
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={confirmDeleteChat}>Delete</Button>
        </Modal.Footer>
      </Modal>

      {/* ratings modal */}
      <Modal show={showReviewModal} onHide={() => setShowReviewModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Reviews for {reviewConsultant?.username || reviewConsultant?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ maxHeight: "333px", overflowY: "auto" }}>

            {reviewConsultant?.review?.length ? (
              reviewConsultant.review.map((text, index) => (
                <div key={index} className="mb-3">
                  <p className="mb-1 text-dark" style={{ fontSize: "0.95rem" }}>"{text}"</p>
                  <div className="text-warning" style={{ fontSize: "1rem" }}>
                    {renderStars(reviewConsultant.ratingArray?.[index])}
                  </div>
                  <hr />
                </div>
              ))
            ) : (
              <p className="text-muted">No reviews yet for this consultant.</p>
            )}
          </div>
        </Modal.Body>
      </Modal>




      <Offcanvas style={{ height: '35%' }} scroll={true} placement={'top'} show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <a href="https://www.priests.africa" class="navbar-brand" style={{ "color": '#CCCCCC', margin: 5 }} > <img src="./logo.png" width="110" />  </a>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            {!user ? (
              <Button variant={isSignedIn ? 'light' : 'success'} style={{ borderColor: '#C7BEBE', margin: 4, marginTop: 8, height: 50, borderRadius: 100, fontSize: 20 }}
                className="w-100"
                onClick={handleGoogleSignup} >
                Sign in with Google
              </Button>
            ) : (
              <div>

                <Button variant={isSignedIn ? 'light' : 'success'} style={{ borderColor: '#C7BEBE', margin: 4, marginTop: 8, height: 50, borderRadius: 100, fontSize: 20 }}
                  className="w-100" onClick={handleSignOut}>
                  Sign Out ({user.displayName})
                </Button>

              </div>
            )}


            {/* <Button variant='light' 
              style={{ borderColor: '#C7BEBE', margin: 4, marginTop: 8, height: 50, borderRadius: 100, fontSize: 20 }} 
              className="w-100" 
              onClick={() => setShowModalQuestionaire(true)}>
               <img src="./questionaire.png" width="35" /> <>Questionaire</>
            </Button> */}


            <Button variant='light'
              style={{ borderColor: '#C7BEBE', margin: 4, marginTop: 8, height: 50, borderRadius: 100, fontSize: 20 }}
              className="w-100"
              onClick={handleAdvice}>
              <FaFeatherPointed />
              {/* <img src="./cowrieblack.png" width="30" />  */}
              <>Priests</>
            </Button>
          </div>


        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default App;